import moduleName from '../moduleName';

export default {
  AUTHORS_UPDATED: `${moduleName}/AUTHORS_UPDATED`,
};
